// extracted by mini-css-extract-plugin
module.exports = {"table":"consent-manager-ConsentManagerSelectionTable__table--3rVgK"};